






















































































































	import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
	import axios from 'axios';
	import { api } from '@/api';

	@Component
	export default class UserForm extends Vue {
		
		public user: any = {
			id: null,
			first_name: '',
			last_name: '',
			email: '',
			password: '',
			password_confirmation: ''
		}

        @Prop()
		userData: any;
		
		@Watch('userData')
		onDataChange(user: any) {
			this.$refs.form.validate();
		}

		public loading: boolean = false;
		public valid: boolean = false;
		public password_confirmation: string = '';
		public passwordHidden: boolean = true;

		public emailRules: ( (v: string) => void )[] = [
            (v: string) => !!v || 'E-mail is required',
            (v: string) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ]

        public passwordRules: ( (v: string) => void )[] = [
            (v: string) => {
                if(v && v.length > 0 && v.length < 8) {
                    return 'Password needs minimum of 8 characters.'
                }
                return true;
            }
        ];
    
        public confirmPasswordRules: ( (v: string) => void )[] = [
            /* (v: string) => !!v || 'You have to confirm password', */
            (v: string) => !( v !== this.getPassword()) || 'Passwords do not match',
		];
		
		public getPassword(): string {
            return this.user.password;
		}
        
		public getPayload() {
			return {
				first_name: this.user.first_name,
				last_name: this.user.last_name,
				email: this.user.email,
				password: this.user.password,
				password_confirmation: this.user.password_confirmation
			}
		}

		public $refs!: {
            form: HTMLFormElement // fix for this.$refs.form.valdiate(); TS error
		}

		public update() {

			if (! this.$refs.form.validate()) {
				return;
			}

			let payload = this.getPayload();

			this.loading = true;

			axios.patch(api.path('v1.admin.users.single', { id: this.user.id }), payload)
				.then(res => { 
					this.$toast.success( res.data.message );
					this.user.password = '';
					this.user.password_confirmation = '';
				})
				.finally(() => this.loading = false);
		}

		public created() {
			this.user.id = this.userData.id;
			this.user.first_name = this.userData.first_name;
			this.user.last_name = this.userData.last_name;
			this.user.email = this.userData.email;
		}

	}
